import axios from '../request'
import qs from 'qs'
import { commonFormatDown } from '@/util'

// 今日订单列表
export const getTodayOrders = (data) => {
  return axios({
    url: `/acquire/queryTodayOrders`,
    method: 'post',
    data
  })
}

// 历史订单列表
export const getHistoryOrders = (data) => {
  return axios({
    url: `/acquire/queryOrdersByPage`,
    method: 'post',
    data
  })
}

// 订单详情
export const getOrderDetail = (data) => {
  return axios({
    url: `/acquire/queryOrderDetail`,
    method: 'post',
    data
  })
}

// 订单导出
export const exportAcquireRecordExcel = async (data) => {
  const res = await axios({
    url: `/acquire/exportAcquireRecordExcel`,
    method: 'post',
    data: qs.stringify(data),
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    responseType: 'blob'
  })
  commonFormatDown(res)
}

// 新收单
// get order list by page
export const getAcquireOrderList = (data) => {
  return axios({
    url: `/acquire/queryOrders`,
    method: 'post',
    data
  })
}

// query ethoca notify list
export const getEthocaNotifyList = (data) => {
  return axios({
    url: `/acquire/queryEthocaNotify`,
    method: 'post',
    data
  })
}

// query rdr notify list
export const getRdrNotifyList = (data) => {
  return axios({
    url: `/acquire/queryRdrNotify`,
    method: 'post',
    data
  })
}

// ethoca dispute decision
export const ethocaDisputeDecision = (data) => {
  console.log('data:', data)
  return axios({
    url: `/acquire/ethocaDecision`,
    method: 'post',
    data
  })
}

// query merchant rdr info
export const getMerchantRdrInfo = (data) => {
  return axios({
    url: `/acquire/rdrInfo`,
    method: 'post',
    data
  })
}

export const exportEthocaAlert = async (data) => {
  const res = await axios({
    url: `/acquire/exportEthoca`,
    method: 'post',
    data: qs.stringify(data),
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    responseType: 'blob'
  })
  commonFormatDown(res)
}

export const exportRdrAlert = async (data) => {
  const res = await axios({
    url: `/acquire/exportRdr`,
    method: 'post',
    data: qs.stringify(data),
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    responseType: 'blob'
  })
  commonFormatDown(res)
}
